import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Complete form
 */
export default async function completeForm(
  form_data_id: FormMetaData["form_data_id"],
) {
  const res = await fetchOrchidAPI(
    `/api/notes/v1/forms/complete/${form_data_id}`,
    { method: "PUT", body: JSON.stringify({ completed: true }) },
  );
  if (!res.ok) {
    throw new Error(
      `failed to complete form: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
